import { connect } from "react-redux";
import RmView from "./rmView";
import { bindActionCreators } from "redux";
import {
  fetchRmTicketDetails,
  postUpdateRMStatus,
  postTicketAssignment,
  postRmRemark,
  fetchRmTicketStatus
} from "services/redux/maintenance/rmTicket/action";
import { documentUploadUrl } from "services/redux/fileUpload/action";
import {getSiteData, calculateDistance, getDistanceData, refreshAfterSiteCheckout} from "../../../services/redux/DistanceCalculator/action";

const mapStateToProps = (state) => ({
  pmTicket: state.pmTicketReducer.pmTicket,
  rmTicketDetails: state.rmTicketReducer.rmTicketDetails,
  rmStatus: state.rmTicketReducer.rmStatus,
  siteData: state.leadDataReducer.siteData,
  engDistanceData: state.leadDataReducer.engDistanceData,
  distanceDetails: state.leadDataReducer.distanceDetails,
  activeDistanceCheckin: state.loginReducer?.userProfile?.active_distance_checkin || null,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      postUpdateRMStatus,
      documentUploadUrl,
      postRmRemark,
      fetchRmTicketStatus,
      fetchRmTicketDetails,
      postTicketAssignment,
      getSiteData,
      calculateDistance,
      getDistanceData,
      refreshAfterSiteCheckout,
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(RmView);
